<script lang="ts">
    import type { PageProps } from '@kestrel/server';
    import ApmBoundary from '@shared/components/apm-boundary/ApmBoundary.svelte';
    import TrackingEsi from '@shared/components/tracking-esi/TrackingEsi.svelte';
    import TileListRoute from '@tilelist/application/wiring/TileListRoute.svelte';

    let { data }: PageProps<typeof import('./page.server.ts')> = $props();
</script>

<ApmBoundary scope="tilelist">
    {#if data.state === 'success'}
        <TrackingEsi requests={data.payload.trackingRequests} />
        <TileListRoute result={{ state: 'success', payload: data.payload.initialSession }} />
    {:else}
        <TileListRoute result={data} />
    {/if}

    {#snippet failed()}
        <TileListRoute result={{ state: 'error' }} />
    {/snippet}
</ApmBoundary>
